import { GridColDef } from '@mui/x-data-grid-pro'
import { Protocol } from '../../../Typescript/StuartPy/Protocol'

type protocolColDef = GridColDef & {
  field: keyof Protocol
}

export const protocolCols: protocolColDef[] = [
  {
    field: 'ProtocolID',
    headerName: 'Protocol ID',
    width: 100,
  },
  {
    field: 'EthicsNumber',
    headerName: 'Ethics Number',
    width: 150,
  },
  {
    field: 'ProtocolTitleShort',
    headerName: 'Protocol Title',
    flex: 1,
  },
]
